import * as Sentry from "@sentry/angular";
import {Injectable} from "@angular/core";
import {config} from "../../../config";

import {isErrorCaptured, MapError} from "../../../lib/shared/errors";

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler extends Sentry.SentryErrorHandler {
  constructor() {
    // Pass options to Sentry's ErrorHandler here. For Example:
    super({
      showDialog: false,
      logErrors: true,
    });
  }
  override handleError(error: unknown): void {
    error = MapError(error);

    if (isErrorCaptured(error)) {
      return;
    }

    if (config.isLocal) {
      console.error(error);
    }
    super.handleError(error);
  }
}
